import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WifiLowIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 19.6L9.56 16.96C10.32 16.3 11.16 15.96 12 15.96C12.84 15.96 13.68 16.3 14.44 16.96L12 19.6Z" />
    </SvgIcon>
  );
});
